import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAllWorkersAction } from "../../../../../redux/actions/workersActions";
import DropdownIcon from "../../../components/DropdownIcon/DropdownIcon";
import { ReactComponent as CheckIcon } from "../../../../../assets/icons/Checkbox.svg";
import { ReactComponent as MinusIcon } from "../../../../../assets/icons/minus-cirlce.svg";

import { AiOutlinePlusCircle } from "react-icons/ai";

const Worker = ({ formik, modalData, updateModalState }) => {
  const dispatch = useDispatch();
  const { workers: dataList } = useSelector((state) => state.workersPagination);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [profileErrMessage, setProfileErrMessage] = useState(false);

  const workers = modalData?.workers || [];

  const addData = () => {
    if (workers) {
      if (workers?.find((item) => item._id === selectedItem._id)) {
        setProfileErrMessage(true);
      } else {
        const updatedWorkers = [
          ...workers,
          {
            id: selectedItem._id,
            fullName: selectedItem.fullName,
          },
        ];
        setProfileErrMessage(false);
        updateModalState("workers", updatedWorkers);
      }
    } else {
      const workderData = [selectedItem];
      setProfileErrMessage(false);
      updateModalState("workers", workderData);
    }
    setSelectedItem("");
    setOpenDropdown(false);
  };

  const removeWorker = (id) => {
    if (workers?.length === 1) {
      updateModalState("workers", []);
    } else {
    }
    const updatedWorkers = workers.filter((w) => w.id !== id);
    updateModalState("workers", updatedWorkers);
  };

  useEffect(() => {
    dispatch(getAllWorkersAction());
  }, [dispatch]);

  return (
    <>
      <div>
        <div className="dropdown-input courses">
          <div className="left">
            <div className="input-box">
              <TextField
                sx={{
                  "& input": { fontSize: "12px", marginRight: "32px" },
                  marginTop: "24px",
                }}
                InputLabelProps={{
                  style: { fontSize: "12px", color: "#3F3F3F" },
                }}
                fullWidth
                label="Əməkdaş"
                autoComplete="off"
                value={selectedItem?.fullName || ""}
                disabled
                onClick={() => setOpenDropdown(!openDropdown)}
              />

              <DropdownIcon
                setOpenDropdown={setOpenDropdown}
                openDropdown={openDropdown}
              />
            </div>

            <ul className={`dropdown-body ${openDropdown ? "active" : ""}`}>
              {dataList?.map((item, index) => (
                <li key={item._id} onClick={() => setSelectedItem(item)}>
                  {modalData?.courses?.find((obj) => obj._id === item._id) ? (
                    <CheckIcon />
                  ) : null}
                  <h4>{item.fullName}</h4>
                </li>
              ))}
            </ul>
          </div>

          <div className="right">
            <button
              disabled={!selectedItem}
              onClick={() => addData()}
              className="add-class"
            >
              <AiOutlinePlusCircle />
            </button>
          </div>
        </div>

        {formik.errors.courses && formik.touched.courses && (
          <small className="validation-err-message">
            {formik.errors.courses}
          </small>
        )}

        <ul className="category-list courses-li">
          {profileErrMessage ? (
            <small className="category-error-message">
              İxtisas artıq mövcuddur.
            </small>
          ) : null}

          {workers.map((worker, index) => (
            <li>
              <div className="top">
                {`${index + 1}. ${worker?.fullName}`}
                <div className="minus-icon-con">
                  <MinusIcon
                    className="minus-icon"
                    onClick={() => removeWorker(worker.id)}
                  />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Seçilmiş əməkdaşların siyahısı */}
      {workers.length > 0 && (
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            gap: "6px",
          }}
        ></div>
      )}

      {formik.errors.workers && formik.touched.workers && (
        <small className="validation-err-message">
          {formik.errors.workers}
        </small>
      )}
    </>
  );
};

export default Worker;
